import "./loader.css";
export const Loader = () => {
  return (
    <div className="loader_wrapper">
      <span className="loader"></span>
    </div>
  );
};
